import { FETCHING_QUOTEID_SUCCESS, FETCHING_QUOTEID_START } from '../actions/actiontypes'

export default function(state = [], action) {
	switch(action.type){
		case FETCHING_QUOTEID_START:{
			return [];
		}
		case FETCHING_QUOTEID_SUCCESS:{
			return [...state, ...action.payload];
		}
		default:
			return state;
	}
}